export const environment = {
  production: false,
  // url: 'https://api.denefits.com:5004/',
  request_url: 'https://demoapi.credee.com/customer/',
  socketBaseUrl: 'https://demoapi.credee.com/',
  // request_url: 'https://api.credee.com/customer/',
  open_api_url: 'https://demoapi.credee.com/whitelabel/',
  // open_api_url: 'https://demoapi.credee.com/whitelabel/',
  public_url: 'https://demoapi.credee.com/admin/',
  // public_url: 'https://api.denefits.com:3002/',
  business_url: 'https://demoapi.credee.com/business/',
  // business_url: 'https://api.denefits.com:3003/',
  app_version: 3000,
  app_type: 3,
  device_type: 0,
  device_token: 'Website',
  env: 't1',
  customer_panel_link: 'https://demo.credee.com/customer/',
  // business_panel_link: 'https://demobusiness.denefits.com/',
  business_panel_link: 'https://demo.credee.com/business/',
  request_panel_link: 'https://demo.credee.com/request/',
  request_panel_link_v2: 'https://demo.credee.com/request/finance/',
  intercom_id: 'lur7iuqc',
  app_deep_link: 'https://credeecutomer.page.link/download-app',
  plaid_redirect_url: 'https://demo.credee.com/request/oauth-page',
  // plaid_redirect_url: 'https://test.credee.com/request/oauth-page',
  plaid_public_key: 'ccc1e7ed2525e866d48e2bba35afc5',
  plaid_counter: 180,
  stripe_pk: 'pk_test_51M3weOKg5KVQU6rZWg7Lhvme6TK1t163HNYgScXxDdfTsbthLEjJGrK1eqGlkO9DL79AbJbOxbBZ1kQTZ2vq8vHt00qkG7ObgF',
  server_url: 'https://demo.credee.com',
  googleKey:'AIzaSyAC-sYjuX1Avr6W_kNtfL06HQtNnWluAvs',
  landing_page_url: 'https://dev.credee.com/',
  recaptchaSiteKey: '6LfMNW8qAAAAAA_2dwD8L2KedLs8v-te98G4364s',
};
